import React, { Component } from 'react'
import Modal from 'react-responsive-modal'
import { firebaseApp, fireStore } from '../../firebase'
import 'firebase/firestore'
import CircularProgress from '@material-ui/core/CircularProgress'

import { observer } from 'mobx-react';

const ToEditAdmin = observer( class ToEditAdmin extends Component {
	constructor(props){
		super(props)

		this.state = {
			deal:{},
			open: false,
			imageUploaded: false
		}

		this.updateDeal = this.updateDeal.bind(this)
		this.addCategory = this.addCategory.bind(this)
		this.addDays = this.addDays.bind(this)
		this.addTime = this.addTime.bind(this)
		this.addAge = this.addAge.bind(this)
		this.addSavings = this.addSavings.bind(this)
		this.addDates = this.addDates.bind(this)
		this.addDescription = this.addDescription.bind(this)
		this.objectIsEmpty = this.objectIsEmpty.bind(this)
		this.addKeywords = this.addKeywords.bind(this)
		this.submitChanges = this.submitChanges.bind(this)
		this.completeSubmission = this.completeSubmission.bind(this)
		this.engageModal = this.engageModal.bind(this)
		this.changeImage = this.changeImage.bind(this)
		this.changeAddress = this.changeAddress.bind(this)
		this.changeFree = this.changeFree.bind(this)
		this.addURL = this.addURL.bind(this)

	}
	firebaseRef =  firebaseApp.database().ref('locations')
	firestoreDb = firebaseApp.firestore()
	fireStorage = firebaseApp.storage()
	mongo = process.env.REACT_APP_MONGO
	progress = 0

	componentDidMount(){
		console.log('toEditProps',this.props);
		this.setState({deal:this.props.toEdit})
	}

	objectIsEmpty(){
		let isMyObjectEmpty = !Object.keys(this.state.deal).length;
		return isMyObjectEmpty
	}

	changeFree(e){
		let { deal } = this.state
		let key = e.target.name

		if(this.objectIsEmpty()){
			deal = Object.assign(deal,this.props.toEdit)
		}

		if(document.getElementById(e.target.id).checked){
			deal[key] = true
			this.setState({deal}, () => console.log(this.state))
		} else {
			deal[key] = false
			this.setState({deal}, () => console.log(this.state))
		}

	}


	updateDeal(e){
		let key = e.target.name
		let value = e.target.value
		let { deal } = this.state
		if(this.objectIsEmpty()){
			deal = Object.assign(deal,this.props.toEdit)
		}
		deal[key] = value
		this.setState({deal})

	}

	addURL(e){
		let { deal } = this.state
		let val = e.target.value

		if(this.objectIsEmpty()){
			deal = Object.assign(deal,this.props.toEdit)
		}

		deal.signup_url = val

		this.setState({deal},()=> console.log("url added", this.state.deal));

	}

	addCategory(e){
		let { deal } = this.state
		let cat = e.target.name

		if(this.objectIsEmpty()){
			deal = Object.assign(deal,this.props.toEdit)
			if(cat === 'all-cats'){
		      if(document.getElementById(e.target.id).checked){
		        deal.category.play = true
		        deal.category.eat = true
		        deal.category.parents = true
		        this.setState({deal})
		      }else{
		        deal.category.play = false
		        deal.category.eat = false
		        deal.category.parents = false
		        this.setState({ deal })
		      }

		    } else {
		      if(document.getElementById(e.target.id).checked){
		        deal.category[cat] = true
		        this.setState({ deal })
		      }else{
		        deal.category[cat] = false
		        this.setState({ deal })
		      }
		    }

		} else {
			if(cat === 'all-cats'){
		      if(document.getElementById(e.target.id).checked){
		        deal.category.play = true
		        deal.category.eat = true
		        deal.category.parents = true
		        this.setState({deal})
		      }else{
		        deal.category.play = false
		        deal.category.eat = false
		        deal.category.parents = false
		        this.setState({ deal })
		      }

		    } else {
		      if(document.getElementById(e.target.id).checked){
		        deal.category[cat] = true
		        this.setState({ deal })
		      }else{
		        deal.category[cat] = false
		        this.setState({ deal })
		      }
		    }
		}

	}

	addDays(e){
		let day = e.target.name
	    let { deal } = this.state
		if(this.objectIsEmpty()){
			deal = Object.assign(deal,this.props.toEdit)
		}

	    if(day === "any_day"){
	      if(document.getElementById(day).checked){
	        deal.days[day] = true
	        deal.days.Monday = true
	        deal.days.Tuesday = true
	        deal.days.Wednesday = true
	        deal.days.Thursday = true
	        deal.days.Friday = true
	        deal.days.Saturday = true
	        deal.days.Sunday = true

	      } else {

	        deal.days[day] = false
	        deal.days.Monday = false
	        deal.days.Tuesday = false
	        deal.days.Wednesday = false
	        deal.days.Thursday = false
	        deal.days.Friday = false
	        deal.days.Saturday = false
	        deal.days.Sunday = false

	      }
	      this.setState({deal})

	    } else {

	      if(document.getElementById(day).checked){
	        deal.days[day] = true

	      } else {
	        deal.days[day] = false
	      }

	      this.setState({deal})

	    }
	}

	addTime(e){
		let targetTime = e.target.name
	    let { deal } = this.state
	    let val = e.target.value
	    if(this.objectIsEmpty()){
			deal = Object.assign(deal,this.props.toEdit)
		}

	    if(targetTime === "custom_time"){
	      deal.time[targetTime] = val
	      deal.time.all_day = false
          deal.time.morning = false
          deal.time.afternoon = false
          deal.time.evening = false
	      this.setState({deal})

	    } else if(targetTime === "all_day"){

	      if(document.getElementById(targetTime).checked){
	        deal.time.all_day = true
	        deal.time.morning = true
	        deal.time.afternoon = true
	        deal.time.evening = true

	        this.setState({deal})
	      } else {
	        deal.time.all_day = false
	        deal.time.morning = false
	        deal.time.afternoon = false
	        deal.time.evening = false

	        this.setState({deal})
	      }

	    } else {

	      if(document.getElementById(targetTime).checked){
	        deal.time[targetTime] = true
	        this.setState({deal})
	      }else{
	        deal.time[targetTime] = false
	        this.setState({deal})
	      }
	    }

	}

	addAge(e){
		let { deal } = this.state
	    let ageGroup = e.target.name
	    if(this.objectIsEmpty()){
			deal = Object.assign(deal,this.props.toEdit)
		}

	    if(ageGroup === "all_ages") {
	      if(document.getElementById(ageGroup).checked){
	        deal.age[ageGroup] = true
	        deal.age.adults = true
	        deal.age.teens = true
	        deal.age.pre_teens = true
	        deal.age.toddlers = true
	        deal.age.infants = true
					deal.age.zeroTwo = true
					deal.age.threeSix = true
					deal.age.sevenTen = true
					deal.age.elevenSeventeen = true
					deal.age.eighteenPlus = true
	      }else{
	        deal.age[ageGroup] = false
	        deal.age.adults = false
	        deal.age.teens = false
	        deal.age.pre_teens = false
	        deal.age.toddlers = false
	        deal.age.infants = false
					deal.age.zeroTwo = false
					deal.age.threeSix = false
					deal.age.sevenTen = false
					deal.age.elevenSeventeen = false
					deal.age.eighteenPlus = false
	      }
	      this.setState({deal},()=> console.log(this.state))

	    } else {

	      if(document.getElementById(ageGroup).checked){
	        deal.age[ageGroup] = true
	      } else {
	        deal.age[ageGroup] = false
	      }
	      this.setState({deal},()=> console.log(this.state))
	    }

	}

	addSavings(e){
		let { deal } = this.state
		let saving = e.target.name
	    let val = e.target.value
	    if(this.objectIsEmpty()){
			deal = Object.assign(deal,this.props.toEdit)
		}

	    if(saving === "price"){
	      deal.price = Number(val) * 100
	      deal.percent = null
	      this.setState({deal})
	    }

	    if(saving === "percent"){
	      if(val){
	      	deal.percent = val + '%'
	      	deal.price = null
	      } else {
	      	deal.percent = null
	      	deal.price = null
	      }

	      this.setState({deal})
	    }

	}

	addKeywords(e){
		let { deal } = this.state
		let keywords = e.target.name
	    let val = e.target.value
	    if(this.objectIsEmpty()){
			deal = Object.assign(deal,this.props.toEdit)
		}

		deal.keywords = val
		this.setState({deal})

	}

	addDates(e){
		let date_type = e.target.name
	    let val = e.target.value
	    let { deal } = this.state
		if(this.objectIsEmpty()){
			deal = Object.assign(deal,this.props.toEdit)
		}

		deal[date_type] = val

		if(date_type === 'expiration'){
			deal.mili = new Date(val).getTime();
		}

		if(date_type === 'list_date'){
			deal.list_mili === new Date(val).getTime();
		}

	    this.setState({deal}, ()=> console.log(deal))
	}

	addDescription(e){
		let key = e.target.name
	    let val = e.target.value
	    let { deal } = this.state
		if(this.objectIsEmpty()){
			deal = Object.assign(deal,this.props.toEdit)
		}

		deal[key] = val

	    this.setState({deal})

	}

	submitChanges(){
		this.engageModal()
	}

	completeSubmission(){
		let { deal } = this.state;
		let { mainStore } = this.props.myStores;

		this.setState({open: !this.state.open},()=> {
			this.props.closeModal();
			mainStore.editEvent(deal,this.props.collection);
		})

	}

	engageModal(){
		this.setState({open: !this.state.open})
	}

	changeImage(e){

		let files = e.target.files
	    let imageUrl = null
	    let downloadURL = null

	    let { deal } = this.state
		if(this.objectIsEmpty()){
			deal = Object.assign(deal,this.props.toEdit)
		}

	    //let img = document.createElement('img')
	    let imageFile = file

	    // stop everything if cancel was clicked and no image
	    if(files.length <= 0){
	      return
	    }


	    // if user changes the file grab the recent file
	    const file =  files.length > 0 ? files[files.length -1]
	                                   : files[0]


	    var reader = new FileReader()

	    reader.onload = function(e){

	      document.getElementById('promo_img').src = e.target.result
	      var img = new Image()

	      img.onload = function(){

	        var canvas = document.createElement("canvas");

	        let ctx = canvas.getContext("2d");
	        ctx.drawImage(img, 0, 0);

	        var MAX_WIDTH = 720;
	        var MAX_HEIGHT = 720;
	        var width = img.width;
	        var height = img.height;

	        if (width > height) {

	          if (width > MAX_WIDTH) {
	            height *= MAX_WIDTH / width;
	            width = MAX_WIDTH;
	          }

	        } else {

	          if (height > MAX_HEIGHT) {
	            width *= MAX_HEIGHT / height;
	            height = MAX_HEIGHT;
	          }

	        }

	        canvas.width = width;
	        canvas.height = height;
	        ctx = canvas.getContext("2d");
	        ctx.drawImage(img,0,0,width,height);

	        var dataurl = canvas.toDataURL();
					var imageData = dataurl.split(',')[1];
	        let filename = "adminChange" + Math.random().toString(36).substring(2, 10);

					var functionUrl = "https://us-central1-funily-deals.cloudfunctions.net/uploadPromoImage"

					var options = {
						method: "POST",
						body: JSON.stringify({
							title: filename,
							data: imageData
						})
					}

					//  FETCH IMAGE URL
					fetch(functionUrl,options)
					.then(res => res.json())
					.then(function (json) {
						deal.downloadURL = json.url;
						this.setState({
							imageUploaded: true,
							deal
						},() => {
							setTimeout(function() {
								this.setState({imageUpload: false})
							}.bind(this), 3000)
						})
					}.bind(this))
					.catch(err => console.log(err)); //FETCH

	      }.bind(this) // image on load

	        img.src = e.target.result

	    }.bind(this) // reader.onload

	      reader.readAsDataURL(file)
	}

	changeAddress(e){
		let key = e.target.name
	    let val = e.target.value
	    console.log('blur',val)
	    let { deal } = this.state
		if(this.objectIsEmpty()){
			deal = Object.assign(deal,this.props.toEdit)
		}
		deal[key] = val

		var geoCode = "https://us-central1-funily-deals.cloudfunctions.net/geoCode";
		var geoOptions = {
			method: "POST",
			body: JSON.stringify({
				location:deal.address
			})
		}

		// get geoJSON data
		fetch(geoCode,geoOptions)
		.then(result => {
			return result.json()
		})
		.then(function(jsonRes) {

			let currentLocation = [jsonRes.location.coordinates[1],jsonRes.location.coordinates[0]];
    	deal.location.coordinates = currentLocation
    	this.setState({deal})

		}.bind(this))
		.catch(err => console.log('error getting coordinates', err))


	}

	render() {
		let deal = !this.objectIsEmpty() ? this.state.deal : this.props.toEdit
		if(deal){
			return (
				<div style={styles.container}>
					<h1>Edit Event</h1>
					<div className='form-group'>
						<label htmlFor='dealTitle'>Event Title</label>
						<input className="form-control" type='text' id='dealTitle' name='dealTitle' defaultValue={deal.dealTitle} onChange={this.updateDeal}/>
					</div>

					<div className='form-group'>
						<div className="checkbox">
							<label htmlFor='free'>
							<input type='checkbox' id='free' name='free' checked={deal.free} onChange={this.changeFree} />Free
							</label>
						</div>
					</div>

						<div className='form-group'>
			        <label htmlFor='address'>Promotion Image</label>
			        <div className='form-group'>
			        <CircularProgress variant='determinate' value={this.progress} />
			        </div>
			        {
			          (this.state.imageUploaded) ?
			          <div>
			          <p style={{color:'red'}}>Image Uploaded</p>
			          </div>
			          : null
			        }
		        	<input className='form-control' type='file' name='image' ref='image' onChange={this.changeImage} required/>
		        </div>

		        <div>
		        	<img id='promo_img' src={deal.downloadURL} />
		        </div>

						<div className='form-group'>
		        <h4 className='text-center'>Funily Category</h4>
		          <div className="checkbox">
		            <label>
		              <input checked={deal.category.eat} type="checkbox" name='eat' value='eat' id='eat' onChange={this.addCategory}/> Eat
		            </label>
		          </div>
		          <div className="checkbox">
		            <label>
		              <input checked={deal.category.play} type="checkbox" name='play' value='play' id='play' onChange={this.addCategory}/> Play
		            </label>
		          </div>
		          <div className="checkbox">
		            <label>
		              <input checked={deal.category.parents}  type="checkbox" name='parents' value='parents' id='parents' onChange={this.addCategory}/> Parents' Night Out
		            </label>
		          </div>
		          <div className="checkbox">
		            <label>
		              <input type="checkbox" name='all-cats' id='all-cats' onClick={this.addCategory} /> All of the Above
		            </label>
		          </div>
		        </div>

		        <div className='form-group'>
		          <h4 className='text-center'>Days Category</h4>
		          <div className="checkbox">
		            <label>
		              <input checked={deal.days.Monday} type="checkbox" name='Monday' value='Monday' id='Monday' onChange={this.addDays}/> Monday
		            </label>
		          </div>
		          <div className="checkbox">
		            <label>
		              <input checked={deal.days.Tuesday}  type="checkbox" name='Tuesday' value='Tuesday' id='Tuesday' onChange={this.addDays}/> Tuesday
		            </label>
		          </div>
		          <div className="checkbox">
		            <label>
		              <input checked={deal.days.Wednesday}  type="checkbox" name='Wednesday' value='Wednesday' id='Wednesday' onChange={this.addDays}/> Wednesday
		            </label>
		          </div>
		          <div className="checkbox">
		            <label>
		              <input checked={deal.days.Thursday}  type="checkbox" name='Thursday' value='Thursday' id='Thursday' onChange={this.addDays}/> Thursday
		            </label>
		          </div>
		          <div className="checkbox">
		            <label>
		              <input checked={deal.days.Friday}  type="checkbox" name='Friday' value='Friday' id='Friday' onChange={this.addDays}/> Friday
		            </label>
		          </div>
		          <div className="checkbox">
		            <label>
		              <input checked={deal.days.Saturday}  type="checkbox" name='Saturday' value='Saturday' id='Saturday' onChange={this.addDays}/> Saturday
		            </label>
		          </div>
		          <div className="checkbox">
		            <label>
		              <input checked={deal.days.Sunday}  type="checkbox" name='Sunday' value='Sunday' id='Sunday' onChange={this.addDays}/> Sunday
		            </label>
		          </div>
		          <div className="checkbox">
		            <label>
		              <input checked={deal.days.any_day}  type="checkbox" name='any_day' value='any_day' id='any_day' onChange={this.addDays}/> Any Day
		            </label>
		          </div>
		        </div>

		        <div className='form-group'>
		        <h4 className='text-center'>Time Category</h4>
		          <div className="checkbox">
		            <label>
		              <input checked={deal.time.all_day} type="checkbox" name='all_day' value='all_day' id='all_day' onChange={this.addTime}
		              disabled={deal.time.custom_time}
		              /> All Day
		            </label>
		          </div>
		          <div className="checkbox">
		            <label>
		              <input checked={deal.time.morning}  type="checkbox" name='morning' value='morning' id='morning' onChange={this.addTime}
		              disabled={deal.time.custom_time}
		              /> Morning
		            </label>
		          </div>
		          <div className="checkbox">
		            <label>
		              <input checked={deal.time.afternoon}  type="checkbox" name='afternoon' value='afternoon' id='afternoon' onChange={this.addTime}
		              disabled={deal.time.custom_time}
		              /> Afternoon
		            </label>
		          </div>
		          <div className="checkbox">
		            <label>
		              <input checked={deal.time.evening}  type="checkbox" name='evening' value='evening' id='evening' onChange={this.addTime}
		              disabled={deal.time.custom_time}
		              /> Evening
		            </label>
		          </div>
		          <div>
		            <input className="form-control" type='text' name='custom_time' placeholder="ENTER specific timeframe (i.e. 8:00am-3:30pm)" defaultValue={deal.time.custom_time || null} id='custom_time' onChange={this.addTime} />
		          </div>
		        </div>

		        <div className='form-group'>
		        <h4 className='text-center'>Age Group</h4>

							<div className="checkbox">
		            <label>
		              <input checked={deal.age.zeroTwo}  type="checkbox" name='zeroTwo' value='zeroTwo' id='zeroTwo' onChange={this.addAge}/> 0-2 yrs. old
		            </label>
		          </div>
							<div className="checkbox">
		            <label>
		              <input checked={deal.age.threeSix}  type="checkbox" name='threeSix' value='threeSix' id='threeSix' onChange={this.addAge}/> 3-6 yrs. old
		            </label>
		          </div>
							<div className="checkbox">
		            <label>
		              <input checked={deal.age.sevenTen}  type="checkbox" name='sevenTen' value='sevenTen' id='sevenTen' onChange={this.addAge}/> 7-10 yrs. old
		            </label>
		          </div>
							<div className="checkbox">
		            <label>
		              <input checked={deal.age.elevenSeventeen}  type="checkbox" name='elevenSeventeen' value='elevenSeventeen' id='elevenSeventeen' onChange={this.addAge}/> 11-17 yrs. old
		            </label>
		          </div>
							<div className="checkbox">
		            <label>
		              <input checked={deal.age.eighteenPlus}  type="checkbox" name='eighteenPlus' value='eighteenPlus' id='eighteenPlus' onChange={this.addAge}/> 18+ yrs. old
		            </label>
		          </div>

		        </div>

					<h4 className='text-center'>Enter Price or Percent Savings</h4>
					<p className='text-center' style={{color: 'red'}}>Remove current price or percent to make changes.</p>
			        <div className='container col-md-12'>
			          <div className='col-md-6'>
			            <div className='input-group'>
			            <span className="input-group-addon">$</span>
			            <input className='form-control' style={{marginRight: 20, width: 150}}  type='number' step='.01' name='price' id='price' ref='price' defaultValue={(deal.price /100).toFixed(2) || null } placeholder='Price (19.99)' onChange={this.addSavings}
			            disabled={deal.percent}
			            />
			            </div>
			          </div>

			          <div className='form-group col-md-6'>
			            <div className='input-group'>
			            <input className='form-control text-center' type='text' name='percent' id='percent' ref='percent' defaultValue={deal.percent || null} placeholder='Percent (25)' onChange={this.addSavings}
			            disabled={deal.price}
			            />
			            <span className='input-group-addon'>%</span>
			            </div>
			          </div>

					<h4 className='text-center'>KeyWords</h4>
			        <div className='form-group'>
			          <input className='form-control' type='text' name='keywords' ref='keywords'
			          defaultValue={deal.keywords || null } placeholder='ENTER keywords (i.e. jump,sports,wings,etc)' onChange={this.addKeywords} />
			        </div>

			        <div className='form-group'>
				        <label htmlFor='start'>List Date</label>&nbsp;&nbsp;
				        <input type='date' id='list_date' name='list_date' ref='list_date'
				         defaultValue={deal.list_date ? deal.list_date : deal.start_date} onChange={this.addDates}/>
			        </div>

			        <div className='form-group'>
				        <label htmlFor='start'>Start Date</label>&nbsp;&nbsp;
				        <input type='date' id='start_date' name='start_date' ref='start_date'
				         defaultValue={deal.start_date} onChange={this.addDates}/>
			        </div>

			        <div className='form-group'>
				        <label htmlFor='expire'>Expiration Date</label>&nbsp;&nbsp;
				        <input type='date' id='expiration' name='expiration' ref='expiration' defaultValue={deal.expiration} onChange={this.addDates} />
			        </div>

			        <h4 className='text-center'>Address</h4>
			        <div className='form-group'>
			        	<input className='form-control' type='text' id='address' name='address' ref='address' defaultValue={deal.address}
			        		onBlur={this.changeAddress} />
			        </div>

			        <h4 className='text-center'>Description</h4>
			        <div className='form-group'>
			        <textarea className='form-control'
			                  name='description'
			                  ref='description'
			                  placeholder='Enter Details about your deals or paste company information.'
			                  rows={10}
			                  defaultValue={deal.description || null}
			                  onChange={this.addDescription}
			        ></textarea>

			        <input
			              className='form-control'
			              type='url'
			              name='signup_url'
			              ref='signup_url'
			              defaultValue={deal.signup_url || null}
			              onChange={this.addURL}
			              placeholder='ENTER URL (MUST include "http" or "https")'
			        />

			        </div>

			        <div className='form-group'>
			        <button className='btn btn-success btn-block' onClick={this.submitChanges}>Submit Changes</button>
			        <button className='btn btn-warning btn-block' onClick={this.props.closeModal}>Cancel Making Changes</button>
			        </div>

					</div>
					<Modal
						open={this.state.open}
						onClose={this.engageModal}
						animationDuration={1000}
						center>
						<h4>Your deal will be submitted for approval.  Please confirm that you are ready to submit your changes.</h4>
						<button
							className='btn btn-success btn-block'
							onClick={this.completeSubmission}
							>Submit My Changes for Approval</button>
						<button
							className='btn btn-warning btn-block'
							onClick={this.engageModal}
							>Double Check Changes</button>

					</Modal>
				</div>
			)
		}

		return (
			<div>
				<h1>No Deal to Edit</h1>
				<button onClick={this.props.closeModal}>Close</button>
			</div>
		)
	}
});

const styles = {
	container: {
		width: "100%",
		marginTop: 200
	}
}

export default ToEditAdmin



// WEBPACK FOOTER //
// ./src/components/admin/ToEditAdmin.js